import React, { PureComponent } from 'react';
import { Button, Form, Slider } from 'antd';
import { services } from '@comall-backend-builder/core';
import { language } from '../../../language';
import { EntryList, FormItemLayout, ConfigFormDecorator } from '../../tools';
import { ImageAdItem } from './image-ad-item';
import { ImageAdTips } from './image-ad-tips';
import './index.less';

const FormItem = Form.Item;

const MAX_ENTRY_COUNT = 10;
const interpolate = services.interpolate;
/**
 * 图文组件-配置表单
 */

const templates = [
    {
        id: '1',
        name: '一行一个',
    },
    {
        id: '2',
        name: '一行两个',
    },
    {
        id: '3',
        name: '一行三个',
    },
];

class LandscapeImageCom extends PureComponent<any> {
    state = {
        templateId: this.props.value.showStyle || '1',
    };

    WrapImageAdItem = (props: any) => {
        const { uploadAction, selector, sourceRoot } = this.props;
        return (
            <ImageAdItem
                {...props}
                sourceRoot={sourceRoot}
                selector={selector}
                uploadAction={uploadAction}
            />
        );
    };
    handleClickTemplates = (id: string) => {
        const { form, onChange } = this.props;
        const formValue = form.getFieldsValue();

        this.setState(
            {
                templateId: id,
            },
            () => onChange({ ...formValue, showStyle: id })
        );
    };

    render() {
        const {
            form: { getFieldDecorator },
            linkTypes,
            linkTypeMode,
        } = this.props;
        const formItemLayout = FormItemLayout;
        return (
            <Form className="landscape-image-box">
                <FormItem {...formItemLayout} label="选择模板">
                    {[
                        getFieldDecorator('showStyle', {}),
                        templates.map((item) => (
                            <Button
                                type={this.state.templateId === item.id ? 'primary' : 'default'}
                                shape="round"
                                style={{ marginRight: '16px' }}
                                key={item.id}
                                onClick={() => this.handleClickTemplates(item.id)}
                            >
                                {item.name}
                            </Button>
                        )),
                    ]}
                </FormItem>
                <FormItem {...formItemLayout} label="页面边距">
                    {getFieldDecorator('margin')(<Slider max={48} min={0} />)}
                </FormItem>

                <FormItem {...formItemLayout} label="图片边距">
                    {getFieldDecorator('marginImage')(<Slider max={48} min={0} />)}
                </FormItem>

                <FormItem {...formItemLayout} label="图片圆角">
                    {getFieldDecorator('borderRadius')(<Slider max={48} min={0} />)}
                </FormItem>

                <FormItem>
                    {getFieldDecorator('entry', {
                        initialValue: [],
                    })(
                        <EntryList
                            linkTypes={linkTypes}
                            linkTypeMode={linkTypeMode}
                            maxCount={MAX_ENTRY_COUNT}
                            renderItem={this.WrapImageAdItem}
                            renderTips={ImageAdTips}
                        />
                    )}
                </FormItem>
                <p className="entry-tip">
                    {interpolate(language.getText('components.ImageAd.tips'), {
                        max: MAX_ENTRY_COUNT,
                    })}
                </p>
            </Form>
        );
    }
}

export const LandscapeImage = ConfigFormDecorator(LandscapeImageCom);
